import { fetchApi } from '@/config/axiosSetting';
import { PatchBodyPartTwoVehicleInformationType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyPartTwoVehicleInformation/patchBodyPartTwoVehicleInformation.type';

export const patchBodyPartTwoVehicleInformationFunction = ({
  id,
  data,
}: PatchBodyPartTwoVehicleInformationType) => {
  return fetchApi.patch(`/body/reports/${id}/vehicle_information/part_two/`, {
    ...data,
  });
};
